import store from '@/store';
import ApiService from '@/services/ApiService';
import UtilsService from '@/services/UtilsService';
import { SubscribeQuery } from '@/queries';
import BotQueries from '@/queries/bot.queries';
import { Integration, Feature } from '@/models';
import { OmniChatSchema } from '@omnichat/omnichat-model';
import AuthService from './AuthService';

function getAllBots(currentUser: any) {
  const query = BotQueries.getAll(currentUser.retailer.objectId);

  return ApiService.get(UtilsService.buildFullPath(query as SubscribeQuery));
}

function getBotById(currentUser: any, botIntegrationId: string) {
  const query = BotQueries.getById(currentUser.retailer.objectId, botIntegrationId);

  return ApiService.get(UtilsService.buildFullPath(query)).then(
    (res) => res.results && res.results.length && res.results[0],
  );
}

async function createBot(bot: OmniChatSchema.BotStateMachine) {
  const data = {
    platform: OmniChatSchema.IntegrationType.bot,
    configuration: bot,
    retailer: store.state.auth.currentUser.retailer,
    status: 'INACTIVE',
  }
  const result = await ApiService.post('/parse/classes/Integration/', data);
  return result;

}

function deleteBot(botIntegrationId: string) {
  return ApiService.del(`/parse/classes/Integration`, botIntegrationId);
}

function updateBot(botIntegrationId: string, botIntegration: Integration) {
  return ApiService.put(`/parse/classes/Integration/${botIntegrationId}`, botIntegration);
}

async function loadBotFeatures() {
  const botFeatures = [];

  let featureFlags = store.state.featureFlag && store.state.featureFlag.featureFlags;

  if (!featureFlags || featureFlags.length === 0) {
    await store.dispatch('loadFeatureFlags');

    featureFlags = store.state.featureFlag && store.state.featureFlag.featureFlags;
  }

  // for (const featureFlag of featureFlags) {
  //   switch (featureFlag.feature) {
  //     case Feature.BotMakerChannels:
  //       botFeatures.push({
  //         title: 'Redirecionar por canal',
  //         value: 'CHANNEL_STATE_CHANGE_HANDLER',
  //         icon: 'mdiChatProcessingOutline',
  //         feature: Feature.BotMakerChannels,
  //       });
  //       break;

  //     default:
  //       break;
  //   }
  // }

  return botFeatures;
}

async function inactivateBot() {
  const sessionToken = await AuthService.getSessionToken();
  
  return internalApiRequest('/bots/inactivate', { sessionToken });
}

async function convertToV2(bot: Integration) {
  const sessionToken = await AuthService.getSessionToken();

  return internalApiRequest('/adapter', {
    adminSessionToken: sessionToken,
    objectId: bot.objectId
  });
}

async function loadBotDefaultTeam () {
  const sessionToken = await AuthService.getSessionToken();

  return internalApiRequest('/defaultTeam', { sessionToken });
}

async function loadBotDefaultTrandingHours () {
  const sessionToken = await AuthService.getSessionToken();

  return internalApiRequest('/defaultTrandingHours', { sessionToken });
}

async function internalApiRequest(path: string, payload: object, method: string = 'POST') {
  if (method === 'GET' && payload) {
    let urlParameters = Object.entries(payload).map(e => e.join('=')).join('&');
    path += '/?'+ urlParameters;
  }
  return ApiService.post('/parse/functions/internalAPI', {
    api: 'botmaker-publish',
    method,
    path,
    version: 'v1',
    payload,
  });
}

const BotsService = {
  getAllBots,
  getBotById,
  createBot,
  inactivateBot,
  deleteBot,
  updateBot,
  loadBotFeatures,
  convertToV2,
  loadBotDefaultTeam,
  loadBotDefaultTrandingHours,
};

export default BotsService;